// 用于 Hub 站内搜索索引 + 详情页场景模块
// Miral 写法：作平台语境（同页切换、不用 Discord），不作「在 Miral 选/写」的主语
function s(title, text) {
  return { title: title, text: text }
}

var HUB_SEARCH_SCENARIOS = {
  'kimi-k3-review': [
    s('Kimi K3 怎么做长文档研究', '别只要摘要，让它标页码、冲突数据和待核实结论；漏了就把状态摘要贴回去再要一轮。'),
    s('Kimi K3 读 PDF 竞品报告', '我要求按结论 / 证据页码 / 冲突点 / 待核实四栏输出，比「总结一下」靠谱得多。'),
    s('Kimi K3 编程怎么用', '先限定只能改哪些文件，让模型先计划再逐文件修改；一次动太多容易牵一发动全身。'),
    s('Kimi K3 改 Vue/React 小组件', '我会只让它动一个校验文件；它多改无关组件时，退回并写清禁止修改范围。'),
    s('Kimi K3 上下文丢失怎么办', '把目标、已确认事实、未完成项和禁止修改项压成状态摘要，再继续下一轮。'),
    s('Kimi K3 能生成图片吗', '更适合理解图片和写 prompt；成品图用 Seedream、FLUX 或 GPT Image 出。'),
    s('Kimi K3 写生成提示词', '让它输出主体、场景、光线、比例和不要出现的元素，复制进 Seedream 或 FLUX 连出几版。'),
    s('Kimi K3 规划完用什么出图', 'brief 定稿后比较 Seedream、FLUX 和 GPT Image，按画面风格和文字需求选模型。'),
    s('研究资料怎么出产品图', 'Kimi K3 整理 brief 和 prompt，Seedream 或 GPT Image 负责最终出片。'),
    s('研究资料转成产品图', '先让 Kimi K3 出创意简报和分镜，再用 Seedream 或 GPT Image 出片。'),
    s('Kimi K3 做网站原型', '可规划页面结构和前端草稿，真实项目里我仍会测兼容性、响应式和交互。'),
    s('Kimi K3 智能体怎么做', '限制工具、写清停止条件，高影响操作保留人工确认。'),
    s('Kimi K3 和 GPT 写代码怎么选', '长材料整理和分步规划我会先试 Kimi K3；单行 bug 有时轻量模型更省事。'),
    s('Kimi K3 做落地页文案结构', '先出信息架构和区块说明，视觉终稿仍交给 GPT Image 或 Seedream。'),
    s('视觉提示词怎么改进', '补主体、场景、构图、镜头、光线、尺寸和禁止元素，再只改最弱的部分。')
  ],
  'claude-fable-5-review': [
    s('Claude Fable 5 长期编码怎么用', '先写目标、架构边界和完成标准，用阶段摘要推进，再小步修改并验证。'),
    s('Claude Fable 5 路由重构怎么控范围', '我会贴「禁止修改清单」，每阶段记录已完成和风险，避免它顺手改掉支付或登录模块。'),
    s('Claude Fable 5 分析复杂文档', '要求区分事实、推断和建议，并为关键结论标页码；脚注和正文混淆时要指出再改。'),
    s('Claude Fable 5 智能体任务', '保存阶段状态、限制工具权限，高影响操作设置人工确认。'),
    s('Claude Fable 5 工具调用失败', '核对工具名、参数、权限和真实报错，只修复当前失败步骤。'),
    s('Claude Fable 5 Token 成本怎么降', '删重复上下文、用阶段摘要、限制输出长度，简单任务交给轻量模型。'),
    s('Claude Fable 5 回答太长怎么办', '要求先给短结论，再按指定数量列证据或行动项。'),
    s('创意简报怎么出主视觉', 'Claude Fable 5 定 brief，GPT Image、Seedream 或 FLUX 出片。'),
    s('Claude Fable 5 规划完用什么出图', 'brief 定稿后比较 Seedream、FLUX 和 GPT Image，按画面风格和文字需求选模型。'),
    s('Claude Fable 5 做落地页 brief', '让它出信息层级、主视觉方向和渠道尺寸，再比选 GPT Image 和 Seedream。'),
    s('Claude 和 GPT 编程怎么选', '跨文件、多阶段任务我倾向 Claude Fable 5；快改小模块有时 GPT 类模型更轻。'),
    s('营销简报后做什么短视频', '视觉素材用图片模型出片，关键帧再用 Sora 2 做成 5–8 秒动态版本。'),
    s('Claude Fable 5 被安全策略拦住', '拆成更小、更具体的子任务重试，别硬绕必要保护。')
  ],
  'seedream-ai-image-generator-review': [
    s('Seedream 电商主图怎么做', '提示词里写产品材质、台面、柔光和「电商主图、干净背景」，连出几版挑边缘最清楚的一张。'),
    s('Seedream 怎么做产品图', '用 Seedream 5，描述产品 + 材质 + 光线 + 用途，连出 3 版对比。'),
    s('Seedream 亚马逊白底主图', '我写「纯白背景、产品居中、商业摄影、亚马逊产品图」，多生成几版挑边缘最利的一张。'),
    s('Seedream 和 FLUX 怎么选', '赶时间跟描述用 Seedream；交摄影质感用 FLUX.2。Miral 里两个模型同页切换就行。'),
    s('Seedream 提示词怎么写', '用日常描述写产品、场景、光线和用途即可，做亚马逊、Shopify、Instagram 内容都够用。'),
    s('AI 独立站横幅图', '提示词加 16:9、品牌色背景、产品 + 生活方式元素；方向定了再切 FLUX 出终稿。'),
    s('Seedream 亚马逊 A+ 场景图', '写产品使用场景、自然光、清晰主体；同一描述和 FLUX 各出一版对比质感。'),
    s('Seedream eBay 商品图', '二手、翻新或小众商品要写清状态、材质和真实光线，别把图做得像过度修饰的广告。'),
    s('Seedream Walmart Marketplace 商品图', '1:1、干净背景、产品居中，日用品和家电类主图要少用夸张滤镜。'),
    s('Seedream WooCommerce 商品图', '独立站商品图写品牌色、系列套装和生活方式场景，后续可换 FLUX 精修质感。'),
    s('Seedream Google Shopping 商品广告图', '产品清楚、浅背景、少文字，把用途写成商品广告图，避免生成太像海报。'),
    s('Seedream 宠物产品主图', '宠物用品 + 使用场景 + 暖色柔光 + 1:1 主图，第二版往往就能用。'),
    s('Seedream 家居场景图怎么出', '写产品 + 客厅/卧室场景 + 自然光 + 生活方式摄影；和纯白底主图分开试。'),
    s('Seedream 3C 数码主图', '金属/玻璃材质写清楚，加柔光或边缘光 + 1:1 电商主图，连出几版挑细节。'),
    s('Seedream 食品摄影提示词', '食物 + 木质台面/大理石 + 俯拍或 45° + 食欲感光线，别堆太多形容词。'),
    s('Seedream TikTok Shop 商品图', '9:16 或 1:1、高饱和背景、产品前景清晰 + 动感构图，和亚马逊主图分开写比例。')
  ],
  'flux-ai-image-generator-review': [
    s('FLUX 珠宝产品图 / 手表微距', '提示词加微距、边缘光、黑色背景、金属反光；Schnell 试构图 → FLUX.2 终稿。'),
    s('Flux Schnell 试构图', '同一条提示词连出多张筛构图，满意再切 FLUX.2 出终稿。'),
    s('FLUX 咖啡生活方式图', '晨光、生活方式摄影、浅景深、暖色调——FLUX.2 第二版往往就能用。'),
    s('FLUX 汽车广告风', '雨后街道、霓虹反射、电影级商业摄影、低角度，这几类词 FLUX 反应很稳。'),
    s('FLUX 新手教程', '用 FLUX.2，提示词里写镜头、光线、材质，连出 3 版再挑。'),
    s('FLUX 和 Midjourney 怎么选', '商业摄影选 FLUX，概念艺术选 Midjourney。需要对比的话 Miral 同工作台都能试。'),
    s('FLUX 护肤品白底图', '柔光、浅景深、米白背景；和 Seedream 差距不大，赶时间二选一即可。'),
    s('FLUX Walmart 产品摄影', '家电、户外用品和日用品写真实材质、硬光产品摄影、干净背景，终稿比草图模型更稳。'),
    s('FLUX Target 商品广告图', '明亮背景、产品前景、生活方式摄影；适合日用品、家居和节日促销视觉。'),
    s('FLUX Wayfair 家居产品图', '家具材质、自然光、室内生活方式、浅景深写清楚，适合家居主图和详情页配图。'),
    s('Flux Pro Ultra 什么时候用', '大尺寸提案、印刷级细节时值得开 Pro Ultra；日常详情页 FLUX.2 通常够。'),
    s('FLUX 3C 数码产品图', '金属边框、玻璃屏幕反光、冷色调、硬光产品摄影——FLUX.2 比 Seedream 更利。'),
    s('FLUX 夜景产品摄影', '霓虹、城市背景、边缘光、高对比；适合耳机、手表、潮牌类广告图。'),
    s('FLUX 家居产品图', '柔光、浅景深、木质或大理石台面 + 生活方式场景，和 Seedream 各出一版对比。'),
    s('FLUX 白底图和 Seedream 对比', '极简白底差距不大，赶时间二选一；带场景和硬质感优先 FLUX。')
  ],
  'midjourney-alternative-online': [
    s('Midjourney 不用 Discord 生图', 'Miral 集成了 Midjourney，浏览器直接用，不用装 Discord。'),
    s('Midjourney 商业图替代', '电商主图试 Seedream，硬质感摄影试 FLUX，带标题海报试 GPT Image——一个平台里都能切。'),
    s('Dreamina / Leonardo 替代', '单模型深度各平台不同；要多模型一条工作流，Miral 把 MJ 和商业模型放一起更省事。'),
    s('AI 游戏原画 / 概念艺术', '概念艺术、超细节、电影级、体积光——MJ 或 SD 3.5 都能试。'),
    s('Midjourney 和 FLUX 配合', 'MJ 定风格 → FLUX/Seedream 出商业终稿 → GPT Image 加文字，全程不用换网站。'),
    s('Midjourney 新手入门', '先定用途（艺术 vs 商业），用同一条提示词试 2–3 版再定稿。'),
    s('Midjourney 包装设计风格探索', '包装设计、品牌色、样机图定方向；产品摄影终稿换 FLUX。'),
    s('AI 奇幻插画提示词', '主体 + 概念艺术 + 体积光；同一条提示词在 MJ 和 SD 各出一版对比。'),
    s('Dreamina 和 Midjourney 怎么选', '单平台深度各不同；要多模型一条工作流，MJ 艺术探索 + 商业模型同页切换更省事。'),
    s('AI 社媒图片生成器怎么选', '艺术风 MJ/SD；电商主图 Seedream；硬质感 FLUX；带字海报 GPT Image——按用途切模型。'),
    s('Midjourney 包装样机图怎么做', '包装设计、品牌色、产品样机图定方向；终稿产品摄影换 FLUX。'),
    s('Stable Diffusion 能替代 Midjourney 吗', '艺术探索两者都可；MJ 氛围感往往更强，SD 更偏风格和线条控制。')
  ],
  'gpt-image-generator-guide': [
    s('GPT Image 生成器在线怎么用', '用 GPT Image 1.5，把标题、风格、比例写进提示词即可，无需 API。'),
    s('AI 文字海报 / 促销海报', '主标题、活动日期、复古或极简风格写清楚；短句比长段落稳。'),
    s('AI 电商卖点图', '三点条目式卖点 + 产品名 + 极简背景，GPT Image 排版比纯艺术模型可控。'),
    s('AI 社媒封面生成', '1:1 Instagram、4:5 信息流、2:3 Pinterest、16:9 横幅图——比例写进提示词减少后期裁剪。'),
    s('GPT Image 和 Qwen 怎么选', '大画面海报视觉试 Qwen；说明型文字排版试 GPT Image，各出一版对比。'),
    s('AI 营销海报生成器', '主标题、副标题和活动信息写清楚，生成后检查字号和换行。'),
    s('GPT Image 和产品图怎么配合', 'Seedream/FLUX 先出无底图，再进 GPT Image 叠标题——Miral 里一条流程走完。'),
    s('GPT Image 菜单 / 价格标签图', '菜名、价格、复古或极简排版；条目式比长描述稳。'),
    s('GPT Image 网站首屏横幅', '16:9、主标题 + 副标题 + 品牌色 + 产品或场景元素，生成后检查换行。'),
    s('GPT Image Shopify 横幅图', '主标题、折扣、产品名和品牌色写清楚，独立站首屏图别塞太多卖点。'),
    s('GPT Image WooCommerce 卖点图', '三点卖点 + 产品名 + 极简背景，适合商品详情页和促销说明图。'),
    s('GPT Image Google Shopping 促销图', '短标题、折扣数字、产品名，文字越短越稳，生成后重点检查字号和换行。'),
    s('GPT Image 界面样机图怎么写', '写网页/应用界面、按钮、配色和布局标注；比纯艺术模型可控。'),
    s('GPT Image 和 Seedream 怎么配合', 'Seedream/FLUX 出画面底图，GPT Image 叠标题和卖点——比一次生成全图省心。'),
    s('GPT Image 促销横幅图比例', '1:1 Instagram、4:5 信息流、2:3 Pinterest、16:9 网站横幅图——比例写进提示词减少后期裁剪。')
  ],
  'qwen-image-generator-review': [
    s('Qwen Image 在线怎么用', '用 Qwen Image 2.0 Pro，描述产品、主标题、场景，加上高分辨率要求。'),
    s('AI Instagram 和 Pinterest 封面生成', '1:1、4:5 或 2:3，写主标题、品牌色、生活方式构图——这几项写全通常第二版就能用。'),
    s('高分辨率 AI 生图', 'Qwen Image 2.0 Pro 适合 2K 级营销海报和详情页配图。'),
    s('Qwen 海报怎么生成', '产品描述 + 高分辨率 + 营销海报 + 主标题写清楚，比堆形容词有效。'),
    s('Qwen 电商详情页配图', '产品 + 使用场景 + 柔和光线 + 详情页风格，按这个顺序写提示词。'),
    s('Qwen Image 和 FLUX 怎么选', '大画面海报 Qwen；硬质感产品摄影 FLUX——各出一版对比最直观。'),
    s('Qwen 黑五和节日促销海报', '促销主题、品牌色、主标题写进提示词；条目式折扣信息换 GPT Image 更稳。'),
    s('Qwen 课程封面怎么写', '课程名 + 插画风 + 16:9 + 蓝绿科技背景，高分辨率记得带上。'),
    s('Qwen 邮件通讯头图怎么写', '16:9 或 2.35:1、大画面视觉 + 主标题；说明型条目排版换 GPT Image。'),
    s('Qwen Shopify 新品发布海报', '新品主题、品牌色、产品和生活方式场景写清楚，适合独立站首屏和邮件头图。'),
    s('Qwen Squarespace 品牌横幅图', '16:9、大画面视觉、品牌色和短标题，适合视觉型独立站首页。'),
    s('Qwen Etsy 商品页封面', '手作感、材质细节、生活方式构图，高分辨率和平台比例都写进提示词。'),
    s('Qwen 品牌海报提示词', '主标题 + 产品 + 品牌色 + 高分辨率 + 营销海报，描述清楚即可。'),
    s('Qwen 和 Seedream 电商怎么选', '大画面海报、封面视觉试 Qwen；跟手快的商业场景图试 Seedream。'),
    s('Qwen 2K 高分辨率出图', '提示词里写高分辨率、2K、营销海报；适合详情页配图和印刷级提案。')
  ],
  'z-image-ai-generator-review': [
    s('Z Image Turbo 在线', 'Z Image Turbo 出图快，适合先连出几版广告方向和配色。'),
    s('AI 横幅图生成', '促销主题、品牌色、横幅图比例写进提示词，连出 3–5 版选方向。'),
    s('Z Image 和 Schnell 怎么选', '广告创意草图试 Z Image；摄影构图试 Flux Schnell——终稿都用 FLUX.2。'),
    s('AI Facebook / Instagram 广告图', 'Z Image 先定构图和配色，满意后换 FLUX 或 Seedream 出终稿。'),
    s('Z Image vs FLUX vs Seedream', 'Z Image 试方向 → FLUX 质感终稿 → Seedream 跟商业描述，Miral 里一条工作流搞定。'),
    s('Z Image 新手教程', '写清用途和比例 → 连出 3 版 → 选中方向再精修，Turbo 别当终稿模型。'),
    s('Z Image 黑五 / 限时促销图', '大促、高对比配色、产品前景；促销日期交给 GPT Image 加字更稳。'),
    s('Z Image Google Shopping 广告草图', '1:1、产品清楚、背景简洁，先试促销配色和构图，终稿换 FLUX 或 Seedream。'),
    s('Z Image eBay 促销图', '适合先试折扣视觉、产品前景和背景色；文字区域留给 GPT Image。'),
    s('Z Image Walmart 活动横幅', '日用品、家电或户外产品写促销主题、品牌色、16:9 横幅图，先筛方向。'),
    s('Z Image YouTube 缩略图草图', '16:9、高对比、主体大，先 Z Image 试构图，满意后 FLUX 精修质感。'),
    s('Z Image 健身饮料海报', '高饱和配色、动感构图、产品前景 + 促销主题，定方向后 FLUX 出终稿。'),
    s('Z Image SaaS 博客封面', '16:9、科技感配色、简洁构图；草图满意后 Qwen 或 FLUX 精修。'),
    s('Z Image 电商促销横幅图', '促销主题、品牌色、16:9 横幅图比例，连出 3–5 版筛方向。'),
    s('Z Image 试方向要连出几版', '通常 3–5 版够筛构图和配色；别在 Turbo 上赌终稿，定方向换 FLUX/Seedream。')
  ],
  'stable-diffusion-online-generator': [
    s('Stable Diffusion online', 'SD 3.5 浏览器打开即用，不用本地显卡——Miral 在线版够入门。'),
    s('不用本地部署 SD', '不想装 ComfyUI 的话，在线版够试插画和角色方向。'),
    s('AI 插画生成 / 动漫风', 'SD 3.5 和 Midjourney 都可试；SD 线条控制有时更灵活。'),
    s('SD 角色设计提示词', '服装、姿态、世界观背景 + 概念艺术 + 超细节，风格词写具体。'),
    s('SD 和 Midjourney 哪个好', '艺术探索两者都可；MJ 氛围感往往更强，SD 更偏风格控制。'),
    s('ComfyUI 替代在线', '在线用 SD 3.5 不需要 ComfyUI；本地高级工作流才需要。'),
    s('SD 国风插画怎么写', '国风、水墨、工笔、传统服饰 + 干净线条 + 柔和光线。'),
    s('SD 游戏角色三视图', '角色设计、正面侧面背面、设定图、白背景。'),
    s('SD 风格化头像怎么写', '肖像 + 风格词（油画、赛博、动漫）+ 干净背景，先宽后窄补细节。'),
    s('SD 游戏场景概念图', '场景、道具、超细节、体积光 + 概念艺术；和 MJ 各出一版对比氛围。'),
    s('SD 在线版和本地 ComfyUI 区别', '在线版浏览器即用、够入门；本地 ComfyUI 适合高级节点和工作流。'),
    s('SD 二次元角色立绘', '动漫风、角色、配色、干净线条；SD 线条控制有时比 MJ 更灵活。')
  ],
  'ai-watermark-remover-online': [
    s('在线去水印', '用 AI 去水印，上传图片后框选标志或文字区域，AI 按周围纹理补全。'),
    s('电商图片清理', '角落标志框选贴边即可；清理后若要商用，记得确认原图授权。'),
    s('去除 TikTok 截图水印', '截图清晰度越高越好；半透明水印建议分两次小范围处理。'),
    s('去水印和 PS 对比', '网页端上传框选就行，不用装 Photoshop，适合运营快速清理。'),
    s('AI 图片清理工具链', '先矫正 → 再去水印 → 再擦手写 → 再生图，Miral 里按这个顺序更自然。'),
    s('去水印操作步骤', '上传 → 框选贴边 → 检查边缘 → 复杂背景再修一次残留。'),
    s('商品图右下角标志怎么去除', '框选略大于标志、尽量贴边，别盖住产品主体。'),
    s('去水印后进 FLUX 做新海报', '素材清理干净后，可以继续用 Seedream/FLUX 做新产品图。'),
    s('去除图片日期戳水印', '框选日期区域、尽量贴边；复杂背景分两次小范围处理更稳。'),
    s('透明重复水印怎么处理', '别一次涂太大，分块小范围框选；半透明水印往往要处理 2 次。'),
    s('去水印后进 GPT Image 加字', '清理标志或角落标记后，用 GPT Image 叠新标题做促销海报。'),
    s('电商商品图批量去标志', '逐张框选、选区贴边；批量整理时先小图试效果再处理正式素材。')
    ,
    s('Shopify 商品图去水印', '供应商图角落标志先小范围框选，清理后再进 Seedream 或 FLUX 换背景。'),
    s('eBay 和 Etsy 图片清理', '日期戳、小标记和多余文字可以分块处理；商品页商用前仍要确认原图授权。'),
    s('Walmart Marketplace 图片去标志', '只处理边角小水印，别覆盖产品主体，处理后检查白底和边缘是否干净。')
  ],
  'ai-background-remover-online': [
    s('免费在线抠图', '上传 JPG、PNG 或 WebP，等 AI 自动识别主体，再下载透明 PNG。'),
    s('人像去背景', '下载前放大检查发丝、耳饰和眼镜边缘。'),
    s('发丝抠图', '用清晰原图，分别放到浅色和深色底上检查细发丝是否缺失。'),
    s('Logo 或签名去背景', '优先高分辨率、细线清楚的原图，避免镂空被填死。'),
    s('宠物图片去背景', '选背景简洁、对比强的照片，100% 检查毛发和胡须。'),
    s('JPG 转透明 PNG', 'JPG 不支持透明通道，去背景后一律保存为 PNG。'),
    s('抠图白边怎么办', '把透明 PNG 放到深色底上定位白边，换对比更强的原图重试。'),
    s('不用 Photoshop 怎么抠图', '不用钢笔描边。AI 自动识别前景并移除整张背景。'),
    s('透明底和白底有什么区别', '透明 PNG 没有固定底色；白底图已经铺上白色像素。'),
    s('手机照片去背景', '尽量用相机原图。聊天压缩缩略图对发丝和玻璃更不友好。'),
    s('证件照换背景', '先出透明 PNG，再按要求铺白色或指定颜色。'),
    s('超过 15MB 的图片', '先压缩再上传。当前页面按单张处理。')
  ],
  'ecommerce-product-background-removal': [
    s('Amazon 白底主图', '把检查过的透明 PNG 铺到纯白画布上，再核对当前类目规范。'),
    s('Shopify 透明商品图', '透明 PNG 可套品牌色和响应式卡片，不必一上来做成白底。'),
    s('eBay / Etsy 刊登图', '保证商品完整、边缘干净，上架前检查背景残影。'),
    s('跨境电商主图', '一张透明 PNG 母版派生不同尺寸，保留真实外形、颜色和标识。'),
    s('玻璃商品去背景', '换对比更强的原图，并在白底和深色底上检查透明区域。'),
    s('商品抠图白边', '深色底上定位白边，再用更高清、对比更强的商品原图重试。'),
    s('一张 PNG 多用到几个平台', '母版共用，最终尺寸、留白和背景按渠道分别导出。'),
    s('去背景后做场景图', '透明 PNG 进 Seedream 或 FLUX，检查外形、颜色和 Logo 有没有被改掉。'),
    s('能批量处理整个目录吗', '目前一次一张。细链、玻璃和毛绒更适合逐张检查。'),
    s('Google Shopping 素材', '商品要和落地页一致，并核对当前广告图规范。'),
    s('服装鞋带怎么检查', '沿轮廓和交叉鞋带看一遍，避免网眼或鞋带被抠断。'),
    s('白底图和透明底怎么分工', '先留透明母版，需要白底时再单独铺白色，不要用白底覆盖母版。')
  ],
  'ai-portrait-background-remover': [
    s('如何免费在线做人像去背景', '上传清晰头肩照，等 AI 自动抠图，再下载透明 PNG。'),
    s('如何把自拍做成 LinkedIn 职业照', '去掉办公室杂乱背景，铺浅灰或纯白后上传。'),
    s('如何做白底或蓝底证件照', '先导出透明 PNG，再铺规定色并按官方尺寸裁切。'),
    s('可以免费去除头像背景吗', '可以。登录后即可处理微信、Instagram 等头像原片。'),
    s('可以在线抠戴眼镜的人像吗', '可以，但要放大检查镜框、镜腿和镜片是否完整。'),
    s('用什么工具做发丝抠图', '用 Miral AI 背景移除；优先相机原图，并在深浅底上检查飞发。'),
    s('用什么工具准备护照签证照背景', '先做人像去背景得到透明母版，再按官方当期底色与尺寸处理。'),
    s('如何修复人像抠图白边', '把透明 PNG 放到深色底定位白边，换对比更强的原片重试。'),
    s('如何解决卷发或儿童照飞发缺失', '用更高清原图，下载前 100% 放大检查发丝边缘。'),
    s('能否用手机自拍做简历白底照', '可以，尽量用未压缩原图；透明母版与白底成品分开保存。'),
    s('如何把办公室自拍变成职业照', '去掉走廊和屏幕杂物，少用猛美颜，保留自然表情。'),
    s('透明底和白底证件照有什么区别', '透明可反复换底色；白底是针对表格的成品导出。')
  ],
  'ai-background-changer-online': [
    s('如何免费在线换照片背景', '先抠出透明主体，再铺咖啡馆、品牌墙或新场景。'),
    s('如何把透明 PNG 做成生活方式图', '选光位接近的场景板合成，母版与封面裁切分开存。'),
    s('如何在抠图后更换背景', '发丝和肩线过双色检查后，再进入场景合成。'),
    s('可以把自拍换成咖啡馆背景吗', '可以，先去背景再合成，并让窗光方向接近脸部高光。'),
    s('可以让 AI 生成场景放在真人后面吗', '可以，用 Seedream / FLUX.2 只生成环境，别改脸和衣服。'),
    s('用什么工具做社媒封面换背景', '先用背景移除拿透明主体，再铺品牌渐变墙并留出标题区。'),
    s('用什么工具做活动海报换背景', '透明主体 + 干净品牌墙；标题字可再进 GPT Image。'),
    s('如何修复换背景后看起来假', '按白边 → 光位 → 色温顺序排查，再决定要不要重做场景。'),
    s('如何解决户外日光换背景光位冲突', '太阳方向要对上，避免正午顶光打在室内脸光上。'),
    s('能否用换背景做视频封面', '可以，按封面比例裁切，确保主体落在安全区。'),
    s('换背景和去背景有什么区别', '去背景得到透明主体；换背景是把主体放进新场景或新底色。'),
    s('这是做 Amazon 白底吗', '不是。上架白底请走电商商品图去背景指南。')
  ],
  'handwriting-eraser-online': [
    s('AI 手写文字擦除', '上传扫描件或照片，框选手写字区域，尽量保留印刷文字和表格线。'),
    s('免费在线擦除手写文字', '先用一页样张试擦除效果，再处理正式合同、试卷或笔记扫描件。'),
    s('AI 试卷手写答案擦除', '保留印刷试题，小范围擦学生答案、草稿和批注，擦完可打印空白卷。'),
    s('保留印刷文字擦除手写字', '涂抹略大于笔迹，不要盖住整行印刷字；题干附近分段处理更稳。'),
    s('扫描件去手写', '照片如果拍斜了，建议先做文档矫正，再擦手写。'),
    s('清理文档批注和红笔标记', '红笔、蓝笔、铅笔都可试；表格线附近小范围多次擦更稳。'),
    s('试卷还原成空白试卷', '擦掉学生答案、错题批注和红笔痕迹后，检查题干和选项是否完整。'),
    s('学生作业手写字擦除', '练习册、作业、表格页先矫正弯曲，再分块擦除手写内容。'),
    s('自动旋转扫描文档再擦手写', '倾斜或旋转的图片先自动旋转和切边，再进入手写擦除。'),
    s('手写擦除和矫正顺序', '先矫正 → 再擦手写 →（可选）去水印，顺序对了补全边缘更自然。'),
    s('AI 文档清理流程', '矫正 → 擦手写 → 去水印 → OCR 或归档，Miral 里可以一条链走完。'),
    s('文档数字化清理', '试卷、合同、笔记扫描件清理后可 OCR；正式合同建议人工复核。'),
    s('表格内手填数字怎么擦', '分段擦、保护表格线，比一次涂整行稳。'),
    s('合同红笔批注能擦吗', '可以，涂抹略大于笔迹，别盖住印刷条款。'),
    s('笔记涂鸦怎么清理', '分块擦、保护印刷文字；表格线附近小范围多次比一次涂整页稳。'),
    s('PDF 导出图片后擦手写', 'PDF 先导出为图片 → 矫正透视 → 再擦手写，顺序对了边缘更自然。'),
    s('合同手写备注怎么清理', '先矫正拉正，再小范围擦批注；正式合同擦完建议人工复核条款。'),
    s('手写擦除后进 OCR 识别', '矫正 → 擦手写 → OCR；文字越清晰识别率越高，模糊照片先重拍。')
  ],
  'image-crop-dewarp-online': [
    s('AI 文档切边矫正', '先自动识别文档边缘，裁掉桌面和黑边，再拉正倾斜、透视或轻微弯曲。'),
    s('免费在线文档矫正怎么试', '可以先上传一张样图看边缘识别、裁剪和增强效果，再决定是否继续处理正式文件。'),
    s('在线自动裁剪文档图片', '上传 JPG、PNG 或 WebP 文档照片后，AI 自动裁剪多余背景并保留正文区域。'),
    s('扫描文档去阴影和文字锐化', '阴影重先去阴影，文字发虚再锐化；合同、票据和试卷都适合这个顺序。'),
    s('文档照片拉直在线处理', '用图片裁剪矫正，上传倾斜或弯曲的文档，AI 识别边缘并拉正。'),
    s('倾斜扫描件修复', '合同、书页、票据、白板、证件类拍照都适用。'),
    s('书页弯曲矫正', '弯曲严重可分两次——先大致拉正，再微调。'),
    s('文档转黑白扫描效果', '切边矫正后选择黑白或灰度增强，手机拍照也能更接近扫描件。'),
    s('白板 OCR 前处理', '透视拉正后文字更易读，适合课件和会议记录。'),
    s('矫正和擦手写顺序', '先裁剪矫正，再用手写擦除；两步连着做就行。'),
    s('AI 文档增强工具链', '矫正 → 擦手写 → 去水印 → OCR 或 AI 生图封面，都在同一平台完成。'),
    s('手机拍合同怎么拉正', '拍时尽量垂直、拍全四角；上传后 AI 自动裁剪黑边并拉直。'),
    s('收据 / 票据拍照矫正', '自动裁剪边缘并拉正，适合 OCR 或归档前预处理。'),
    s('证件拍照怎么矫正', '尽量垂直拍全四角；上传后自动裁剪黑边并拉直，请注意隐私保护。'),
    s('弯曲严重书页分两次矫正', '弯曲大时先大致拉正，满意后再微调；比一次强行拉直更自然。'),
    s('矫正后进 OCR 识别', '透视拉正后文字更易读，适合收据、合同和白板课件归档。'),
    s('手机拍白板怎么拉正', '拍时尽量垂直、避免反光；矫正后文字行更齐，OCR 准确率更高。')
  ]
}

module.exports = HUB_SEARCH_SCENARIOS
